import { render } from "./UiCollapsePanel.vue?vue&type=template&id=2f9d5974&ts=true"
import script from "./UiCollapsePanel.vue?vue&type=script&lang=ts"
export * from "./UiCollapsePanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__